import { Card, StyledBody } from 'baseui/card';
import { LabelSmall, ParagraphXSmall } from 'baseui/typography';
import { useStyles } from '../../hooks/useStyles';
import { MapPointerInfo } from '../../types/app';

export function PointerInfo({ info }: { info?: MapPointerInfo }) {
  const { css, theme } = useStyles();
  if (!info) return null;
  const props = info.properties;
  if (!Object.keys(props).length) return null;

  return (
    <span
      className={css({
        left: `${info.x}px`,
        top: `${info.y}px`,
        position: 'absolute',
      })}
    >
      <Card
        overrides={{
          Root: {
            style: {
              borderTopWidth: '1px',
              borderRightWidth: '1px',
              borderBottomWidth: '1px',
              borderLeftWidth: '1px',
            },
          },
          Contents: {
            style: {
              marginTop: theme.sizing.scale400,
              marginRight: theme.sizing.scale400,
              marginBottom: theme.sizing.scale400,
              marginLeft: theme.sizing.scale400,
            },
          },
          Body: {
            style: {
              marginBottom: 0,
            },
          },
        }}
      >
        <StyledBody style={{ marginBottom: 0 }}>
          {props.name && <LabelSmall>{props.name}</LabelSmall>}
          {props.description && (
            <ParagraphXSmall
              marginBottom={0}
              marginTop={theme.sizing.scale100}
            >
              {props.description}
            </ParagraphXSmall>
          )}
        </StyledBody>
      </Card>
    </span>
  );
}
